/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountOnboardSummary } from './accountOnboardSummary';
import { AccountResponseSpec } from './accountResponseSpec';
import { AccountsOnboardIssues } from './accountsOnboardIssues';


export interface AccountsOnboardResponseSpec { 
    /**
     * Accounts failed during onboarding.
     */
    failed?: Array<AccountsOnboardIssues>;
    /**
     * Accounts succeeded during onboarding.
     */
    succeeded?: Array<AccountResponseSpec>;
    summary: AccountOnboardSummary;
}

